module.exports = __webpack_public_path__ + "static/media/scrollButton.b125deab.png";